import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { API, QUERY_KEYS } from '../constants';
import { NextJsInfo } from '../model';

const apiNextJsInfo = async (baseURL: string) => {
    const response = await axios.get<NextJsInfo>(API.URL_NEXT_JS_INFO, { baseURL });

    return response.data;
};

export const useNextJsInfo = (isEnabled: boolean, baseURL: string) => {
    const { data } = useQuery<NextJsInfo>({
        queryKey: [QUERY_KEYS.NEXT_JS_INFO],
        queryFn: async () => {
            return await apiNextJsInfo(baseURL);
        },
        enabled: isEnabled,
    });

    return data;
};
